export default __webpack_public_path__ + "static/BgImgNj-0704a78badf1a50ac7932b407df5b657.webp";